import { useEffect, useState, useContext } from 'react'

import { AlgoliaContext } from '../context/AlgoliaContext';

const ProfileImage: React.FC<{ src?: string }> = ({ src }) => {
    const [imageSrc, setImageSrc] = useState(src);
    const [hasError, setHasError] = useState(false);

    const { 
        isFullUrl,
        domain
      } = useContext(AlgoliaContext);

    useEffect(() => {
        if (src) { // Check if src is defined
            const fullUrl = isFullUrl(src) ? src : `${domain}${src}`;
            const img = new Image();
            img.src = fullUrl;
            img.onload = () => {
                setImageSrc(fullUrl);
            };
            img.onerror = () => {
                setHasError(true);
            };
        } else {
            setHasError(true);
        }
    }, [src]);

    return (
      <div className='rounded-[8px] md:w-[180px] md:h-[170px] w-[120px] h-[120px]'>
        <img
          className="rounded-[8px] md:w-[180px] md:h-[170px] w-[120px] h-[120px] object-cover"
          src={hasError ? `${domain}/images/profile-profile-holder.png` : imageSrc}
          alt="profile_picture"
        />
      </div>
    );
}

export default ProfileImage
